export function formatNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits: 2
  }).format(value);
}